import { columnTypes } from '../../constants/globals';

export const tableConfig = () => {
  return {   
    columns: [
      {
        key: 'name',
        width: '70%',
        className: '',
        type: columnTypes.value,
      },
      {
        key: 'source',
        width: '20%',
        className: '',
        type: columnTypes.value
      },
    ]
  };
};
